"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderChildrenByTypes = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var renderChildrenByTypes = function renderChildrenByTypes(children, childTypes) {
  var _children = [];

  _react.default.Children.map(children, function (child) {
    if (child) {
      if (childTypes.indexOf(child.type) >= 0) {
        _children.push(child);
      }

      if (child.type === _react.default.Fragment) {
        _children.push.apply(_children, (0, _toConsumableArray2.default)(renderChildrenByTypes(child.props.children, childTypes)));
      }
    }
  });

  return _children;
};

exports.renderChildrenByTypes = renderChildrenByTypes;